export const FILTER_COMMENTS_SUCCESS = 'FILTER_COMMENTS_SUCCESS';

export const FILTER_COMMENTS_SENDING = 'FILTER_COMMENTS_SENDING';

export const FILTER_COMMENTS_FAILED = 'FILTER_COMMENTS_FAILED';
